<template>
  <div>
    <Category class="block md:hidden" />
    <SubCategory />
    <Footer />
  </div>
</template>
<script>
import SubCategory from "../views/SubCategory";
import Category from "../views/Category";
import { mapGetters } from "vuex";
import lang from "../lang.js";
import Footer from "../components/Footer";
export default {
  data() {
    return {
      lang: lang,
    };
  },
  components: { Category, SubCategory,Footer },
  computed: {
    ...mapGetters(["theme", "language"]),
  },

  methods: {
    /**
     * Fetch The Menus.
     *
     * @return void
     */
    getMenus() {
      this.$store
        .dispatch("GET_MENU_ITEMS")
        .then((response) => {
          /**
           * Checking if theme doesn't exists on the local storage then
           * storing the theme and reloading the page again to reflect the
           * theme in all the part of the website.
           */
          if (localStorage.getItem("theme") == null) {
            if (response.data.Menu.design) {
              this.$store.commit("setCurrentTheme", response.data.Menu.design);
              location.reload();
            }
          }
          /**
           * If User has changed the theme then it will update the theme and
           * reload the page to reflect all part of the website.
           */
          if (localStorage.getItem("theme") != response.data.Menu.design) {
            this.$store.commit("setCurrentTheme", response.data.Menu.design);
            location.reload();
          }

          this.buttonSpinner = false;
        })
        .catch((error) => {
          this.buttonSpinner = false;
          if (error.response.status == 404) {
            this.errorMessage = "Please enter valid Menu Code";
          }
        });
    },
    mounted() {
    /**
     * If the link has the MenuHash it will get the Menu Hash details.
     *
     * Else it will hide the page loader and update the `menuHasAvailable`
     * to false so that it can show up input field to ask user for menuHash.
     */
    if (this.$route.params.menuHash) {
      if (Object.keys(this.menu).length == 0) {
        this.$store.commit("updateMenuHash", this.$route.params.menuHash);
        this.getMenus();
      }
    } else {
      this.$store.commit("stopPageLoading");
    }
  },
  },
};
</script>